import {
  Button,
  Divider,
  Heading,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
  useTheme,
  VStack,
} from '@chakra-ui/react'
import DarkModalContainer from './Components/DarkModalContainer'
import useTranslation from 'next-translate/useTranslation'

interface Props {
  isOpen: boolean
  onClose: () => void
  FAQ: FAQ[]
}

export interface FAQ {
  question: string
  response: string
}

const HelpModal = ({isOpen, onClose, FAQ}: Props) => {
  const theme = useTheme()
  const {t} = useTranslation()

  return (
    <DarkModalContainer isOpen={isOpen} onClose={onClose}>
      <ModalHeader p={0}>
        <VStack spacing={7} alignItems='start' color={theme.colors.brand.white}>
          <Heading variant='large' color={theme.colors.brand.white}>
            {t('common:help_modal_title')}
          </Heading>
          <Divider />
        </VStack>
      </ModalHeader>
      <ModalBody pl={0} pr={0} pt={7} pb={7} className='hide-scrollbar'>
        <VStack spacing={7}>
          {FAQ.map(faq => {
            return (
              <VStack spacing={2.5} alignItems='start' key={faq.question}>
                <Text variant='mediumBold' color={theme.colors.brand.primary}>
                  {/* @ts-ignore */}
                  {faq.question}
                </Text>
                <Text color={theme.colors.brand.white} variant='medium'>
                  {/* @ts-ignore */}
                  {faq.response}
                </Text>
              </VStack>
            )
          })}
        </VStack>
      </ModalBody>
      <ModalFooter p={0}>
        <VStack spacing={7} alignItems='flex-center' w='full'>
          <Divider />
          <Button
            w='full'
            variant='textLightPrimary'
            color={theme.colors.text.basic}
            onClick={onClose}>
            {t('common:close_button')}
          </Button>
        </VStack>
      </ModalFooter>
    </DarkModalContainer>
  )
}

export default HelpModal
